<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdProjectInfoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                              <template #left-header>
                                <em-button type="view"
                                           custom-label="查看项目计划详情"
                                           :disabled="actionDisabled('selectOne')"
                                           v-bind:class="'btn btn-outline-primary btn-sm'"
                                           @click="getCurrentScheduling()"
                                           :busy="viewScheduledResult"
                                >
                                </em-button>
                              </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2021-11-19 16:30:37

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "sithMesPrdProjectInfoListView",
        mixins: [emCommonListMixin,emCustomVuexMixin,emTableCheckedMixin,emCommonApiMixin,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
      data(){
          return {

            schedulingForm: {
              headerIds: '',
              schedulingStrategy: 2,
              reSchedule: true,
              beginTime: null,
              endTime: null,
              planType: 2,  //1主计划，2项目计划
            },
            viewScheduledResult: false,
          }
      },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
      methods:{
        getCurrentScheduling() {
          this.viewScheduledResult = true
          //给选中记录id赋值
          this.schedulingForm.prpIds = this.selectIds
          //调用api
          this.$_emApiMixin_get(`${this.$_emApiMixin_entityBaseApi('sithMesPrdProjectPlanPrp')}/ppd?ids=${this.selectIds}`)
              .then(response => {
                //跳转到排产调整页面
                this.$router.push({name: 'sithMesPrdProjectPlanAdjust'
                  , params: {scheduledResult: response,pageType:"list_b"}})
              }).finally(result => this.viewScheduledResult = false)
        },
      }
    };
</script>